import { render, staticRenderFns } from "./campaign-stream-plate.vue?vue&type=template&id=b2859c10&scoped=true&"
import script from "./campaign-stream-plate.vue?vue&type=script&lang=js&"
export * from "./campaign-stream-plate.vue?vue&type=script&lang=js&"
import style0 from "./campaign-stream-plate.vue?vue&type=style&index=0&id=b2859c10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2859c10",
  null
  
)

export default component.exports